<template>
  <div
    class="c-main-menu__featured-section"
  >
    <span
      v-if="model.header"
      class="c-main-menu__featured-section-title xl:hidden"
    >
      {{ model.header }}
    </span>
    <template v-if="!isMobile || model.items.length < 2">
      <featured-menu-item
        v-for="item in model.items"
        :key="item.heading"
        :model="item"
      />
    </template>
    <template v-else>
      <slider
        :items="model.items"
        class="c-inspiration-slider"
        slider-title="Menu featured items"
        show-next-slide-on-mobile
        auto-slide
      />
    </template>
  </div>
</template>

<script>
import Slider from '@/components/Slider.vue'
import FeaturedMenuItem from '@/components/FeaturedMenuItem.vue'
import isMobile from '@/lib/is-mobile'

export default {
  components: {
    FeaturedMenuItem,
    Slider
  },
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isMobile: isMobile()
    }
  },
  mounted() {
    window.addEventListener('resize', this.checkBreakpoint, false)
    window.addEventListener('orientationchange', this.checkBreakpoint, false)
  },
  destroyed() {
    window.removeEventListener('resize', this.checkBreakpoint, false)
    window.removeEventListener('orientationchange', this.checkBreakpoint, false)
  },
  methods: {
    checkBreakpoint() {
      this.isMobile = isMobile()
    }
  }
}

</script>
